import React from "react";
import styled from "styled-components";

import SearchIcon from "../components/icons/Search";

const SearchContainer = styled.div`
  padding: 2.5% 29% 0;

  @media (min-width: 1800px) {
    padding: 40px 0 0;
    width: 32.5%;
    margin: 0 auto 0;
  }
  @media (max-width: 575px) {
    padding: 15px 20px;
    width: 75%;
  }
`;

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 0 1fr;
`;

const InputField = styled.input`
  background-color: transparent;
  border: 1px solid ${props => props.theme.primary};
  padding: 5px 10px;
  height: 20px;
  border-radius: 33px;
  outline: none;
  color: ${props => props.theme.text};
  text-align: right;
  @media (min-width: 1800px) {
    height: 25px;
    border: 2px solid ${props => props.theme.primary};
    font-size: 21px;
  }

  @media (max-width: 575px) {
    height: 18px;
    padding-left: 30px;
  }
`;

const Icon = styled.i`
  width: 40px;
  position: relative;
  left: 15px;
  top: 8px;
  cursor: pointer;
  z-index: 1;
  @media (min-width: 1800px) {
    display: flex;
    top: 0;
    align-items: center;
  }

  @media (max-width: 575px) {
    width: 20px;
    height: 20px;
    position: relative;
    left: 10px;
    top: 7px;
  }
`;

const SearchBar = ({ open, onOpen, onClose }) => {
  return (
    <>
      <SearchContainer>
        <Wrapper>
          <Icon>
            <SearchIcon />
          </Icon>
          <InputField onFocus={onOpen} type="text" />
        </Wrapper>
      </SearchContainer>
    </>
  );
};

export default SearchBar;
